<template>
        <div>
            <v-menu min-width="250" offset-y offset-x>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" fab small class="ma-auto">
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>

                <v-card>
                    <div class="text-center pt-6">
                        <v-avatar
                            tile
                            size="40"
                            color="secondary"
                            class="rounded-lg"
                        >
                            <v-icon large dark v-if="user.name">
                                mdi-alpha-{{
                                    user.name.charAt(0).toLowerCase()
                                }}
                            </v-icon>
                        </v-avatar>
                    </div>
                    <v-list-item class="px-6 mb-3 pt-1">
                        <v-list-item-content class="text-center">
                            <v-list-item-title class="text-caption font-weight-bold">
                                {{ user.email }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item dense class="px-6" @click="openProjectsDialog">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ project.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                Proyecto
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>mdi-swap-horizontal-bold</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list rounded class="py-2" dense>
                        <v-list-item @click="open_password = true">
                            <v-list-item-icon>
                                <v-icon>mdi-lock</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Contraseña</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="userAtLeastIs(user.level, LEVEL_ADMIN)" @click="$router.push({ name: 'Configuration' })">
                            <v-list-item-icon>
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Configuraciones</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="doLogout">
                            <v-list-item-icon>
                                <v-icon>mdi-power</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Cerrar sesión</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>

            <Projects ref="ProjectsDialog"/>
            <formPassword :open="open_password" @close="open_password = false"/>
        </div>
</template>

<script>
import { LEVEL_ADMIN, userAtLeastIs } from '../../plugins/checkPermission'
import Projects from '../projects.vue'
import formPassword from '../formPassword'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'user-menu',
    components: { formPassword, Projects },
    computed: {
        ...mapState({ 
            user: state => state.user.profile,
            project: state => state.projects.selected 
        })
    },
    data() {
        return {
            LEVEL_ADMIN,
            open_password: false
        }
    },
    methods:{
        ...mapActions( { logout: 'user/logout' } ),
        userAtLeastIs,
        openProjectsDialog(){
            this.$refs.ProjectsDialog.openDialog()
        },
        async doLogout(){
            try {
                await this.logout()
                this.$router.push({ name: 'Login' })
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>